
import React from 'react';
import { Badge } from './Icon';

const AppBadge = ({ image }) => {
 
    return (
        <div  style={styles.roundContainer}>
           
                <Badge 
                    src={image} 
                    alt="Contenu" 
                    style={styles.image} />
           
        </div>
    );
};

const styles = {
    roundContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%', // Taille du conteneur du rond
        //width:'100%'
    },
    circle: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '50%', // Rend le div un cercle
       //backgroundColor: 'var(--color-light-green)', // Couleur du fond du cercle
       width:'100%'
    },
    image: {
        width: '100%', // Utilisez 100% pour s'assurer que l'image s'adapte au cercle
        height: '80%', // Utilisez 100% pour s'assurer que l'image s'adapte au cercle
        objectFit: 'contain', // Assure que l'image couvre le cercle, sans déformation
        maxHeight: '150px',
        maxWidth: '150px'
        
    },
};

export default AppBadge;
